import React from 'react'
import { Link } from 'react-router-dom'

export class NotFoundView extends React.Component {
  render () {
    return (
      <div className='container text-center'>
        <h1>Página não encontrada.</h1>
        <hr />
        <Link to='/'>Voltar à página principal</Link>
      </div>
    )
  }
}

export default NotFoundView



// WEBPACK FOOTER //
// ./src/views/NotFoundView/NotFoundView.js